/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateTestDto } from '../../models/create-test-dto';
import { ResponseTestDto } from '../../models/response-test-dto';

export interface TestsControllerCreate$Params {
      body: CreateTestDto
}

export function testsControllerCreate(http: HttpClient, rootUrl: string, params: TestsControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseTestDto>> {
  const rb = new RequestBuilder(rootUrl, testsControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseTestDto>;
    })
  );
}

testsControllerCreate.PATH = '/thalea-pathways/tests';
